/* int-l4-subfooter.js: moved from sections/subfooter.liquid (pdp-html-weight lever 4 batch 2, 2026-11-02). The Liquid values arrive in the JSON island #int-subfoot-data. Do not edit here without the source note. */
  /* Tag the shop link so one CSS rule can style it.
     2026-09-13: the six legacy links bars this used to cover were deleted
     from the theme, so the homepage row is the only bar left that needs it.
     The shared .iq-lb bar styles its own shop link. */
  (function () {
    var D = JSON.parse(document.getElementById('int-subfoot-data').textContent);
    var sel = '.iq-nav__links a';
    function tag() {
      document.querySelectorAll(sel).forEach(function (a) {
        var t = (a.textContent || '').trim().toLowerCase();
        if (t === 'the shop' || t === 'all collections') a.classList.add('iq-shop');
      });
    }

    /* Newsletter signup -> Klaviyo list "Subscribers" (XvVUZa), which is the
       list that triggers the live "Email Welcome Series with Discount" flow.
       Posting to Shopify's /contact endpoint only creates a customer; it does
       not add anyone to that list, so the flow would never fire. The <form>
       keeps the Shopify action as a no-JS fallback. */
    var KLAVIYO_COMPANY = 'UvuWpW';
    var KLAVIYO_LIST    = 'XvVUZa';
    var KLAVIYO_LOCALE  = D.locale;

    /* Gather the icons and the Follow-on-Shop button into one wrapper, so the
       row has exactly three children: heading, signup, socials. That lets the
       CSS lay it out as 1fr / auto / 1fr — equal side columns, which is what
       puts the signup on the true centre of the page rather than in the
       middle of whatever space happens to be left over. */
    function groupSocials(row) {
      if (row.querySelector('.iq-social-group')) return;
      var icons = row.querySelector('.footer__socials');
      var follow = row.querySelector('shop-follow-button');
      if (!icons && !follow) return;
      var g = document.createElement('div');
      g.className = 'iq-social-group';
      (icons || follow).before(g);
      if (icons) g.appendChild(icons);
      if (follow) g.appendChild(follow);
      row.classList.add('iq-row-grid');
    }

    function signup() {
      var row = document.querySelector('.footer__block--socials');
      if (!row || row.querySelector('.iq-signup')) return;
      groupSocials(row);
      var target = row.querySelector('.iq-social-group') || row.querySelector('.footer__socials');

      var f = document.createElement('form');
      f.className = 'iq-signup';
      f.method = 'post';
      f.acceptCharset = 'UTF-8';
      f.action = '/contact#iq-signup';
      /* Bot trap (signup-bots, Nils 2026-11-02): a field people never see and a minimum fill time.
         A filled field or a submit faster than a person can type means a script: it gets the normal thank you,
         but nothing is sent to Klaviyo and no try-ons unlock. */
      var bornAt = Date.now();
      f.innerHTML =
          '<span class="iq-hp" aria-hidden="true" style="position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important"><label>Leave empty<input type="text" name="iq_hp_note" value="" tabindex="-1" autocomplete="off"></label></span>'
        + '<input type="hidden" name="form_type" value="customer">'
        + '<input type="hidden" name="utf8" value="✓">'
        + '<input type="hidden" name="contact[tags]" value="newsletter">'
        + '<span class="iq-signup__inner">'
        + '<span class="iq-signup__label">'
        +   '<span class="iq-signup__label__main">' + D.signup_main + '</span>'
        +   '<span class="iq-signup__label__sub">' + D.signup_sub + '</span>'
        +   '<span class="iq-signup__label__sub">' + D.signup_tryon + '</span>'
        + '</span>'
        + '<span class="iq-signup__field">'
        + '<input type="email" name="contact[email]" required'
        + ' placeholder="' + D.email_placeholder + '" aria-label="' + D.email_aria + '">'
        + '<button type="submit">' + D.signup_submit + '</button>'
        + '</span>'
        + '<p class="iq-signup__msg" role="status" hidden></p>'
        + '</span>';
      target ? row.insertBefore(f, target) : row.appendChild(f);

      var msg = f.querySelector('.iq-signup__msg');
      function say(text) { msg.textContent = text; msg.hidden = false; }

      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = f.querySelector('input[type=email]');
        var email = (input.value || '').trim();
        if (!email) return;
        var hp = f.querySelector('input[name=iq_hp_note]');
        if ((hp && hp.value) || Date.now() - bornAt < 2000) {
          f.querySelector('.iq-signup__field').hidden = true;
          say(D.signup_ok);
          return;
        }
        f.querySelector('button').disabled = true;

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email, locale: KLAVIYO_LOCALE } } }
              },
              relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
            }
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          f.querySelector('.iq-signup__field').hidden = true;
          say(D.signup_ok);
          try { window.intTryonMember && window.intTryonMember(email, 'footer'); } catch (e) {}
        })
        .catch(function () {
          f.querySelector('button').disabled = false;
          say(D.signup_err);
        });
      });
    }

    /* Try It On members (Nils 2026-10-30, option A, try-it-on session 7): an email sign-up anywhere on
       the site (this footer, Join with Intention, the Klaviyo popup, the Find your Word quiz) unlocks the 10 extra
       try-ons a day on this device straight away. Worker POST <endpoint>/tryon/member with the same visitor id as the
       Try It On island (localStorage int-tryon-sid). The Worker stores only the device flag, never the email. */
    if (D.tryon_on) {
    window.intTryonMember = function (email, from) {
      try {
        var sid = localStorage.getItem('int-tryon-sid');
        if (!sid) { sid = 'v' + Array.prototype.map.call(crypto.getRandomValues(new Uint8Array(12)), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); localStorage.setItem('int-tryon-sid', sid); }
        fetch((D.tryon_ep).replace(/\/$/, '') + '/tryon/member', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ sid: sid, email: String(email || ''), from: from || 'site' }), credentials: 'same-origin', keepalive: true }).catch(function () {});
      } catch (e) {}
    };
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail; if (!d || d.type !== 'submit') return;
      var m = d.metaData || {}, em = m.$email || m.email;
      if (em) window.intTryonMember(em, 'popup');
    });
    }

    function init() { tag(); signup(); }
    /* started by the inline stub next to the island, at the same moment the inline code used to register it */
    window.__intSubfootInit = init;
    if (window.__intSubfootDcl) init();
  })();
